import { computed, reactive } from '@/composition/vue/compositionApi'
import { getLoggerService } from '@/core/container/ioc'

/**
 * App-wide registry of async components whose chunk failed to load.
 *
 * Populated from defineAsyncComponentRetryable's error notifications.
 * The header alert (HeaderAlertAsyncLoadFailed) reads `asyncLoadFailedShown` to show itself
 * and calls `requestAsyncComponentRetry()` from its Retry button,
 * which re-runs stored loaders in place without remount or page reload.
 **/

const retryHandlers = reactive(new Set<() => void>())

export const registerAsyncComponentLoadFailure = (retry: () => void) => {
  retryHandlers.add(retry)
}

export const resolveAsyncComponentLoad = (retry: () => void) => {
  retryHandlers.delete(retry)
}

export const requestAsyncComponentRetry = () => {
  const handlers = Array.from(retryHandlers)
  retryHandlers.clear()
  handlers.forEach((retry) => {
    try {
      retry()
    } catch (error) {
      getLoggerService().error('error', `Async component retry handler failed: ${String(error)}`)
    }
  })
}

export const useHeaderAlertsAsyncLoadFailedShown = () => {
  return {
    asyncLoadFailedShown: computed(() => retryHandlers.size > 0),
  }
}
